import { StyleSheet } from 'aphrodite';
import constants from '../../../constants/styles';
let {
  FLAT_BUTTON_COLOR,
  WORKFLOWS_BORDER_COLOR,
  TABLE_HEADER_TEXT_COLOR
} = constants;

let styles = {
  base: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${WORKFLOWS_BORDER_COLOR}`,
    borderRadius: 5,
    padding: 20,
    margin: '10px 0'
  },
  text: {
    fontWeight: 500
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    marginTop: 20
  },
  button: {
    textTransform: 'capitalize',
    backgroundColor: 'inherit',
    color: TABLE_HEADER_TEXT_COLOR,
    border: 0,
    borderRadius: 4,
    fontSize: '0.8em',
    padding: '5px 10px',
    marginRight: 7,
    width: 'auto',
    minWidth: 10,
    ':hover': {
      backgroundColor: WORKFLOWS_BORDER_COLOR
    }
  },
  andButton: {
    textTransform: 'capitalize',
    fontSize: '0.8em',
    fontWeight: 600,
    color: FLAT_BUTTON_COLOR,
    border: `1px solid ${FLAT_BUTTON_COLOR}`,
    borderRadius: 5,
    backgroundColor: 'white',
    minWidth: 30,
    marginRight: 'auto',
    padding: '5px 8px',
    ':hover': {
      backgroundColor: WORKFLOWS_BORDER_COLOR
    }
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/criteriacard/CriteriaCard.styles.js